const cols = [
  {
    title: 'Sajt',
    links: [
      { label: 'Start', href: '#start' },
      { label: 'Om oss', href: '#om-oss' },
      { label: 'Våra hoppborgar', href: '#aktiviteter' },
      { label: 'Försäljning', href: '#forsaljning' },
      { label: 'Kontakt', href: '#kontakt' },
    ],
  },
  {
    title: 'Tjänster',
    links: [
      { label: 'Uthyrning', href: '#tjanster' },
      { label: 'Försäljning', href: '#forsaljning' },
      { label: 'Evenemang', href: '#tjanster' },
      { label: 'Säkerhet', href: '#sakerhet' },
    ],
  },
  {
    title: 'Levererar till',
    links: [
      { label: 'Jönköping', href: '/aktiviteter' },
      { label: 'Tenhult', href: '/aktiviteter' },
      { label: 'Nässjö', href: '/aktiviteter' },
      { label: 'Huskvarna', href: '/aktiviteter' },
      { label: 'Värnamo', href: '/aktiviteter' },
      { label: 'Jönköpings län', href: '/aktiviteter' },
    ],
  },
  {
    title: 'Kontakt',
    links: [
      { label: 'Parkvägen 4, Tenhult', href: '#kontakt' },
      { label: '036-12 34 56', href: 'tel:+4636123456' },
      { label: '070-123 45 67', href: 'tel:+46701234567' },
      { label: 'info@borgakungen.se', href: 'mailto:info@borgakungen.se' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-ink text-cream pt-20 pb-10 overflow-hidden">
      <div className="pointer-events-none absolute -top-24 right-1/3 size-72 rounded-full bg-tomato/30 blur-3xl" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <a href="#start" className="flex items-center gap-3">
              <span className="grid place-items-center size-11 rounded-full bg-tomato shadow-pop">
                <span className="text-xl">👑</span>
              </span>
              <span className="font-display text-2xl font-semibold">
                Borga<span className="text-tomato">kungen</span>
              </span>
            </a>
            <p className="mt-5 text-cream/65 max-w-md text-pretty">
              Familjeföretaget i Tenhult utanför Jönköping. Hoppborgar, hinderbanor, sumodräkter och eventuthyrning i hela Småland — sedan 2002.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['IG', 'FB', 'TT', 'YT'].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="size-10 grid place-items-center rounded-full bg-cream/10 hover:bg-sun hover:text-ink transition-colors text-sm font-bold"
                  aria-label={s}
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="lg:col-span-2">
              <div className="text-xs font-semibold uppercase tracking-wider text-cream/50">{c.title}</div>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-cream/85 hover:text-sun transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <div>© {new Date().getFullYear()} Borgakungen AB · Alla rättigheter förbehållna.</div>
          <div className="flex items-center gap-4">
            <a href="/integritet" className="hover:text-cream">Integritet</a>
            <a href="/cookies" className="hover:text-cream">Cookies</a>
            <a href="#sakerhet" className="hover:text-cream">SS-EN 14960</a>
            <span aria-hidden className="text-cream/20">·</span>
            <span>
              Utvecklad av{' '}
              <a
                href="https://wetterdesign.se"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-cream transition-colors"
              >
                WetterDesign.se
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
